import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService } from '../shared/utils-service';

@Component({
  selector: 'app-telco-audit-trail',
  templateUrl: './telco-audit-trail.component.html',
  styleUrls: ['./telco-audit-trail.component.css']
})
export class TelcoAuditTrailComponent implements OnInit {
	private loggedInUser: any = {};
  constructor(private router: Router, private utils: UtilsService) { 
  	this.loggedInUser = this.utils._checkSession({'page': 'telco-audit-trail'});
  }

  ngOnInit() {
  }
  
  massSearchHistory(){
  	this.router.navigateByUrl('/telco-audit-trail/mass-search-customers-history');
  }
  
  massSubmission(){
  	this.router.navigateByUrl('/telco-audit-trail/mass-submission-history');
  }
  
  activityHistory(){
  	this.router.navigateByUrl('/telco-audit-trail/activity-history');
  }
  
  singleSubmission(){
  	this.router.navigateByUrl('/telco-audit-trail/single-submission-history');
  }
  enquiryHistoryByOther(){
  	this.router.navigateByUrl('/telco-audit-trail/enquiry-history-by-other');
  }
  goToURL(url){
		this.router.navigateByUrl(url);
		}

}



// WEBPACK FOOTER //
// ./src/app/telco-audit-trail/telco-audit-trail.component.ts